import { CONTACT_EMAIL, PRIVACY_UPDATED } from "../legal";
import { SimplePage } from "./SimplePage";

const Section = ({ title, children }) => (
  <div className="mb-5">
    <h2 className="font-bold text-gray-900 mb-1">{title}</h2>
    <div className="text-sm text-gray-700 leading-relaxed space-y-2">{children}</div>
  </div>
);

// Aviso de privacidad (short version)
const Privacy = () => (
  <SimplePage title="Aviso de Privacidad">
    <p className="text-xs text-gray-400 mb-6">Última actualización: {PRIVACY_UPDATED}</p>

    <Section title="Quién es responsable de tus datos">
      <p>conocetuinquilino.com es responsable del tratamiento de los datos personales que se registran en la plataforma. Contacto: <a className="text-amber-700 underline" href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.</p>
    </Section>

    <Section title="Qué datos tratamos">
      <p><strong>Propietarios registrados:</strong> nombre, correo, teléfono, empresa, contraseña cifrada y, si deciden evaluar, foto de identificación oficial y selfie para verificar su identidad.</p>
      <p><strong>Personas evaluadas:</strong> nombre, correo y teléfono que el propietario proporciona, y la evaluación de su experiencia de arrendamiento (calificaciones, comentarios, periodo y, opcionalmente, domicilio del inmueble y evidencia).</p>
      <p>No pedimos ni publicamos datos sensibles (salud, religión, origen, preferencias, etc.).</p>
    </Section>

    <Section title="Para qué los usamos">
      <p>Para operar el historial de arrendamiento: que los propietarios registren y consulten evaluaciones de experiencias de renta, verificar la identidad de quienes evalúan, prevenir abusos, atender disputas y enviar avisos de la cuenta.</p>
    </Section>

    <Section title="Con quién se comparten">
      <p>Las evaluaciones solo las ven propietarios registrados. No vendemos datos. Usamos proveedores para operar el servicio (alojamiento, base de datos, almacenamiento de archivos, correo y pagos), que solo los tratan por nuestra cuenta.</p>
    </Section>

    <Section title="Tus derechos">
      <p>Puedes pedir acceso, rectificación, cancelación u oposición sobre tus datos, o revocar tu consentimiento, escribiendo a <a className="text-amber-700 underline" href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a> con tu nombre, un medio de contacto y lo que solicitas. Respondemos en un máximo de 20 días hábiles.</p>
      <p>Si te evaluaron y no estás de acuerdo, puedes <a className="text-amber-700 underline" href="/disputas">disputar la evaluación</a>; mientras se revisa aparece como "En disputa".</p>
    </Section>

    <Section title="Cambios a este aviso">
      <p>Publicaremos cualquier cambio en esta misma página.</p>
    </Section>
  </SimplePage>
);

export { Privacy };
